/// ////////////////////////////////////////
/// ajax
/// ////////////////////////////////////////
import PCLNAnalytics from '@pcln/analytics'
import { PCLN_BOOTSTRAP_DATA } from '../constants/PCLN-Data'
import packageJson from '../../../package.json'
import axios from 'axios'
import { canUseDOM } from 'exenv'
import { bind, either, evolve, identity, has, is, merge, pipe, propEq, toLower, tap, unless, when } from 'ramda'
import { renameProp } from '../utils/ramda-helpers'
import { URLSearchParams } from 'url'

PCLNAnalytics.appName = packageJson.name
PCLNAnalytics.appVersion = packageJson.version

axios.interceptors.request.use(tap(() => {
  PCLNAnalytics.log({
    category: 'APICall',
    actionType: 'API',
    URL: URL,
    cguid: canUseDOM ? PCLN_BOOTSTRAP_DATA.webstats.clientGUID : ''
  })
}))

axios.interceptors.response.use(identity, (error) => {
  PCLNAnalytics.log({
    category: 'APIError',
    actionType: 'API',
    URL: URL,
    statusCode: error.response.status,
    statusText: error.response.statusText,
    responseText: JSON.stringify(error.response.data),
    cguid: canUseDOM ? PCLN_BOOTSTRAP_DATA.webstats.clientGUID : ''
  })
  return Promise.reject(error)
})

const transformOptionsToConfig = pipe(
  ({ type: method = 'get', url, headers = [], dataType: responseType, data = {}, params = {} }) => ({ method, url, headers, responseType, data, params }),
  evolve({
    method: toLower
  })
)

const addProperDataParameter = unless(
  propEq('method', 'post'),
  pipe(
    renameProp('data', 'params'),
    evolve({
      params: when(is(String), (p) => new URLSearchParams(p))
    })
  )
)

const addContentTypeHeader = when(
  either(propEq('method', 'post'), has('data')),
  evolve({
    headers: merge({ 'Content-Type': 'application/json' })
  })
)

const ajax = pipe(
  transformOptionsToConfig,
  addContentTypeHeader,
  addProperDataParameter,
  bind(axios.request, axios)
)

export { ajax as default, axios }
